export default {
    disabled: 'The company-micro-trend is pinned to this macro-trend'
}
